import { STRATEGYBUILDER_SECTION_NAME } from '../../apollo/queries/GET_TEMPLATE_OVERVIEW'
import { TEMPLATE_STATUS } from '../../apollo/queries/SUBMIT_ANSWERS'

export const getTemplateCategoryStatus = templateList => {
  let templateHasBeenCompleted = true
  let templateHasNotBeenStarted = true
  templateList?.forEach(function (template) {
    //we mark whole category as complete when all REQUIRED templates completed
    if (
      template.isRequired &&
      template.templateStatus !== TEMPLATE_STATUS.COMPLETE
    ) {
      templateHasBeenCompleted = false
    }
    //we mark whole category as not started when all templates are not started
    if (template.templateStatus !== TEMPLATE_STATUS.NOT_STARTED) {
      templateHasNotBeenStarted = false
    }
  })
  if (templateHasNotBeenStarted) {
    return TEMPLATE_STATUS.NOT_STARTED
  }
  if (templateHasBeenCompleted) {
    return TEMPLATE_STATUS.COMPLETE
  }
  return TEMPLATE_STATUS.IN_PROGRESS
}

export const parseDeliverables = deliverablesFromContentful => {
  let result = []
  deliverablesFromContentful?.edges?.forEach(p => {
    const processedPersona = {
      category: p.node?.category,
      name: p.node?.title,
      description: p.node?.description?.description,
      image: p.node?.image?.file?.url,
      url: p.node?.url?.file?.url,
    }
    result.push(processedPersona)
  })
  return result
}

export const findDeliverable = (
  allDeliverables,
  sectionName,
  deliverableName = ''
) => {
  if (allDeliverables) {
    if (sectionName === STRATEGYBUILDER_SECTION_NAME.BRAND_POSITIONING) {
      return allDeliverables.find(d => d.category === sectionName)
    }
    if (sectionName && deliverableName) {
      return allDeliverables.find(
        d => d.category === sectionName && d.name === deliverableName
      )
    }
  }
  return null
}

const getPersonaList = (allDeliverables, sectionName, personas) => {
  let result = []
  personas?.forEach(function (persona) {
    const matchDeliverabe = findDeliverable(
      allDeliverables,
      sectionName,
      persona
    )
    if (matchDeliverabe) {
      result.push(matchDeliverabe)
    }
  })
  return result
}

export default getPersonaList
